import { useRecoilValue } from 'recoil';
import { userAtom } from 'services/user/atoms';

/**
 * @description Hook to get non nullable user from the Recoil store
 * @returns user
 */
export const useUser = () => {
  const user = useRecoilValue(userAtom);

  if (!user) {
    throw new Error('User not found');
  }

  return user;
};
